import React, { useContext } from "react";
import Radio from "~/assets/js/components/Forms/Radio";
import Button from "~/assets/js/components/Button";
import i18n from "~/assets/js/Helpers/i18n";
import { formatDate } from "./formatDateTime";
import { CheckoutContext } from "../../CheckoutProvider";
import { Edit2, Check } from "react-feather";
import PropTypes from "prop-types";

const SelectDaySlot = ({ groupedDeliveryTimes, openTimeSelectPopup }) => {
    const handleOnValueChange = (deliveryDay) => {
        openTimeSelectPopup(deliveryDay);
    };

    const { state: contextState } = useContext(CheckoutContext);

    const sessionTimeSlot = contextState.timeSlot;

    return Object.keys(groupedDeliveryTimes).map((day, keyPosition) => {
        if (sessionTimeSlot && sessionTimeSlot.deliveryDay === day) {
            return (
                <Radio
                    onValueChange={() =>
                        handleOnValueChange(groupedDeliveryTimes[day])
                    }
                    bindName="daySelect"
                    value={day}
                    customStyles="day-select day-select__checked"
                    key={keyPosition}
                    currentValue={day}
                    handleOnClick={() =>
                        handleOnValueChange(groupedDeliveryTimes[day])
                    }
                >
                    <div>
                        <p>
                            <span className="append-bold">
                                {formatDate(day).append}
                            </span>
                            <span>, den {formatDate(day).date}</span>
                        </p>
                        <p>
                            <b>{sessionTimeSlot.timeSlot}</b>
                        </p>
                        {contextState.earlyOnLocation && (
                            <span className="day-select__early-on-location">
                                <Check className="fa-check" />
                                {i18n.t("timeSlotSelect.earyDeliveryConfirmed")}
                            </span>
                        )}

                        <Button
                            label={i18n.t("timeSlotSelect.editSelection")}
                            icon={<Edit2 size={18} />}
                            onClick={() =>
                                handleOnValueChange(groupedDeliveryTimes[day])
                            }
                            variant="secondary"
                            size="XS"
                        />
                    </div>
                </Radio>
            );
        }

        return (
            <Radio
                onValueChange={() =>
                    handleOnValueChange(groupedDeliveryTimes[day])
                }
                bindName="daySelect"
                value={day}
                customStyles="day-select"
                key={keyPosition}
            >
                <p>
                    <span className="append-bold">
                        {formatDate(day).append}
                    </span>
                    <span>, den {formatDate(day).date}</span>
                </p>
            </Radio>
        );
    });
};

export default SelectDaySlot;

SelectDaySlot.propTypes = {
    groupedDeliveryTimes: PropTypes.object,
    openTimeSelectPopup: PropTypes.func,
};
